/**
 * Created by frank.law on 1/30/18.
 */

import React from 'react';
import '../../../css/login.css';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {showUserMessage} from '../../actions/actions';

class MessageAnchor extends React.Component {

    render() {
        const {label, linkType, messageTitle, messageBody, challenge, iconName, onClick} = this.props;

        let linkStyle = "";
        switch (linkType) {
            case 'light':
                linkStyle = 'need-help';
                break;
            case 'dark':
                linkStyle = 'op-link';
                break;
            default:
                break;
        }

        return (
            <div onClick={() => onClick(messageTitle, messageBody, challenge, iconName)} className={linkStyle}>{label}</div>
        );
    }
}

MessageAnchor.propTypes = {
    challenge: PropTypes.string,
    label: PropTypes.string,
    messageTitle: PropTypes.string,
    messageBody: PropTypes.string,
    linkType:  PropTypes.oneOf(['light','dark']),
    iconName: PropTypes.string
};

const mapDispatchToProps = (dispatch) => {
    return {
        onClick: (messageTitle, messageBody, challenge, iconName) => {
            dispatch(showUserMessage(messageTitle, messageBody, challenge, iconName));
        }
    }
};

export default connect(null, mapDispatchToProps)(MessageAnchor);
